import { LS_get, LS_set } from './LS'

export function LS_envGet(): Window['ENV'] {
    return LS_get('env')
}

export function LS_envSet(env: Window['ENV']) {
    LS_set('env', env)
}
